import React from "react";
import Layout from "../components/Layout";
import Seo from "../components/Seo";
import { PageRendererProps } from "gatsby";
import WavesBottom from "../components/WavesBottom";

const ReferralPage = ({ location }: PageRendererProps) => {
  return (
    <Layout location={location}>
      <Seo title={`Teilnahmebedingungen "Freunde werben"`} />

      <section className="py-20 bg-white">
        <div className="container max-w-5xl p-6 m-8 mx-auto">
          <h2 className="w-full my-8 font-bold leading-tight text-center text-gray-800 sm:text-3xl lg:text-5xl">
            getsby GmbH - Teilnahmebedingungen "Freunde werben"
          </h2>

          <h3 className="w-full my-8 font-bold leading-tight text-gray-800 sm:text-2xl lg:text-4xl">
            Vertragsverhältnis
          </h3>
          <p className="mb-8 text-gray-600">
            Diese Teilnahmebedingungen stellen die vertragliche Grundlage
            zwischen dir und der
          </p>
          <p className="mb-8 text-gray-600">
            getsby GmbH,
            <br />
            Maria Jacobi Gasse 1, Media Quarter Marx 3.2, A-1030 Wien
            <br />
            UID: ATU75803025
            <br />
            FN: 538605t des Firmenbuches des HG Wien
            <br />
            E-Mail: office@gets.by
          </p>
          <p className="mb-8 text-gray-600">
            (nachfolgend „getsby“ genannt) dar. Sie gelten für das
            Empfehlungsprogramm „Freunde werben“. Abweichende Bedingungen werden
            nicht anerkannt.
          </p>
          <h3 className="w-full my-8 font-bold leading-tight text-gray-800 sm:text-2xl lg:text-4xl">
            Voraussetzungen für die Teilnahme
          </h3>
          <ol className="mb-8 text-gray-600 list-decimal list-outside">
            <li>
              Jeder registrierte getsby User kann seine interessierten
              Verwandten, Freunde und Bekannten (nachfolgend der „Geworbene“
              oder der „Neukunde“ genannt) getsby empfehlen.
            </li>
            <li>
              Der getsby User wird eine Empfehlungs-E-Mail oder -Link,
              Empfehlungen über Social Media Kanäle (z.B. Facebook, Instagram)
              oder eine persönliche Empfehlung ausschließlich an ihm persönlich
              bekannte Empfänger versenden und bei der Versendung derartiger
              elektronischer Nachrichten beachten, dass die Geworbenen dem
              Erhalt solcher Nachrichten zugestimmt haben.
            </li>
            <li>
              Die Weitergabe des Promotion Codes an Personen, die den getsby
              Usern persönlich nicht bekannt sind oder die keine Empfehlung
              wünschen, ist ebenso wie jegliche Form der geschäftsmäßigen
              Nutzung oder Nutzung in gewerblichem Ausmaß untersagt.
              Insbesondere ist es nicht gestattet, den Promotion Code an
              unbekannte bzw. unbestimmte Personenkreise (z.B. durch
              Publizierung in Internetforen, Gutscheinplattformen, etc.) bekannt
              zu geben.
            </li>
            <li>
              getsby missbilligt jede Form unlauterer Beeinflussung. Der getsby
              User wird jegliches Ausüben von Druck auf Geworbene unterlassen
              und auch sonst keine Handlungen setzen, die rechtswidrig sind oder
              den getsby Usern und/oder getsby einem rechtlichen Risiko
              aussetzen könnten.
            </li>
          </ol>
          <h3 className="w-full my-8 font-bold leading-tight text-gray-800 sm:text-2xl lg:text-4xl">
            Gutschrift
          </h3>
          <ol className="mb-8 text-gray-600 list-decimal list-outside">
            <li>
              Voraussetzung für den Erhalt der Gutschrift ist die Versendung
              oder persönliche Weitergabe des, in der getsby App erhältlichen,
              persönlichen Promotion Codes.
            </li>
            <li>
              Der Werber (bereits registrierte getsby User) erhält die
              Empfehlungs-Gutschrift nur, wenn der Geworbene noch nicht getsby
              Kunde ist, sich in der getsby App mit dem individuellen Promotion
              Code registriert und erfolgreich eine Erstbestellung in der Höhe
              von mindestens 10,- durchführt.
            </li>
            <li>
              Der Geworbene (Neukunde) erhält die Neukunden-Gutschrift nur, wenn
              er bisher noch keine Bestellung getätigt hat, er bei der
              Registrierung den persönlichen Promotion Code in das dafür
              vorgesehene Feld eingibt, so dass eine Zuordnung erfolgen kann und
              eine Erstbestellung von mindestens 10,- durchführt.
            </li>
            <li>
              Pro Bestellung (von mindestens 10,-) kann nur eine Empfehlungs-
              oder Neukundengutschrift eingelöst werden. Die Kombination von
              mehreren Gutschriften aus dieser oder anderer Aktionen bei einer
              Bestellung ist nicht möglich.
            </li>
            <li>
              Gutschriften können nur über die getsby App eingelöst und nicht in
              bar ausbezahlt werden. Sie haben keinen Marktwert, sind nicht auf
              ein anderes Nutzerkonto übertragbar und dürfen nicht verkauft
              werden.
            </li>
            <li>
              Es ist ein Aktionsgutschein pro Bestellung einlösbar. Eine
              Kombination von Aktionsgutscheinen mit anderen Aktionsgutscheinen
              oder anderen Gutscheinen ist nicht möglich. Aktionsgutscheine sind
              nur begrenzte Zeit einlösbar und verlieren ihre Gültigkeit zu dem
              am Aktionsgutschein genannten Datum. Eine Verlängerung ist nicht
              möglich
            </li>
            <li>
              Nicht genutzte Gutschriften der getsby User als auch Neukunden
              verfallen 360 Tage nach Gutschrift.
            </li>
          </ol>
          <h3 className="w-full my-8 font-bold leading-tight text-gray-800 sm:text-2xl lg:text-4xl">
            Gültigkeit
          </h3>
          <ol className="mb-8 text-gray-600 list-decimal list-outside">
            <li>
              Die Aktion „Freunde werben“ gilt bis auf weiteres. Die getsby GmbH
              behält sich vor, die Bedingungen der Aktion „Freunde werben“
              jederzeit zu ändern oder die Aktion einzustellen.
            </li>
            <li>
              Bei Verstoß gegen diese Bedingungen und/oder unsere Allgemeinen
              Geschäftsbedingungen, bei Kontaktierung von Geworbenen, die einer
              solchen nicht zugestimmt haben, bei Verdacht auf Betrug, Versuch
              der Täuschung oder Verdacht auf andere illegale Aktivitäten im
              Zusammenhang mit dem Erlangen oder die Einlösung von Gutschriften,
              behält sich getsby unbeschadet sonstiger Rechte vor, die
              jeweiligen getsby User vom Empfehlungsprogramm auszuschließen
              und/oder bereits erhaltene Gutschriften für ungültig zu erklären
              und zu löschen und/oder deren getsby Konto umgehend zu sperren.
              Weitergehende Ansprüche (insbesondere Schadenersatzansprüche)
              bleiben jeweils unberührt.
            </li>
          </ol>
          <h3 className="w-full my-8 font-bold leading-tight text-gray-800 sm:text-2xl lg:text-4xl">
            Sonstiges
          </h3>
          <ol className="mb-8 text-gray-600 list-decimal list-outside">
            <li>
              Diese Teilnahmebedingungen unterliegen österreichischem Recht
              unter Ausschluss der Vorschriften des internationalen
              Privatrechts. Sollten einzelne Bestimmungen unwirksam sein oder
              werden, so wird dadurch die Wirksamkeit der übrigen Bestimmungen
              nicht berührt.
            </li>
          </ol>
        </div>
      </section>

      <WavesBottom />
    </Layout>
  );
};

export default ReferralPage;
